import React from 'react';
import MaskedInput from 'react-text-mask';
import { PhoneMaskDiv } from './Auth.style';


export const TextMaskCustomPhone = (props) => {
    const { inputRef, ...other } = props;

    return (
        // <PhoneMaskDiv style={{ display: 'flex' }}>
        //     +7 (9
            <MaskedInput
                {...other}
                ref={(ref) => {
                    inputRef(ref ? ref.inputElement : null);
                }}
                mask={[/[+]/, /[7]/, ' ', '(', /[9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}
                placeholder="Телефон *"
                required
            />
        // </PhoneMaskDiv>
    );
}

export const TextMaskCustomSnils = (props) => {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, ' ', /\d/, /\d/]}
            placeholder="СНИЛС *"
            required
        />
    );
}

export const TextMaskCustomDate = (props) => {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /[1-2]/, /[9, 0]/, /\d/, /\d/]}
            placeholder="Дата рождения *"
            required
        />
    );
}
